import { NotificationSidebar } from '@/components/NotificationSidebar';
import { AppProvider } from '@/context/AppProvider';
import { AppRoutes } from '@/routes';

function App() {
  return (
    <AppProvider>
      <NotificationSidebar />
      <AppRoutes />
    </AppProvider>
  );
}

export default App;
